// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"80":"9fb8b743","376":"dd085bec","535":"c3c3ea24","570":"df69f248","619":"b55841c0","650":"e331cd62","815":"1fc3cb6c"}[chunkId] + ".css";
};